<template>
 <!-- 
   :group="{ name: 'g1' }" 
   handle=".handle"
 -->
  <draggable 
    class="dragArea mt-1" 
    tag="ul" 
    :group="{ name: 'g1' }"    
    handle=".handle"
    ghost-class="ghost"
    :categories="categories"


    :list="list" 
    :value="value"
    @input="emitter"
    v-bind="dragOptions"
    
    :component-data="getComponentData()"
    >    
      
      <li class="element" v-for="el, index in realValue" :key="el.id">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
                <div class="col-md-2">
                    <div class="input-group">                        
                        <span class="input-group-text handle"><i class="fa fa-arrows-alt" aria-hidden="true"></i></span>
                        <span class="input-group-text text text-danger" v-on:click="deleteClicked(index)"><i class="fa fa-trash" aria-hidden="true"></i></span>                        
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">                        
                        <input type="text" class="form-control" name="menu_item_label" @change="el.validateError.label.error=false" v-model="el.label">                        
                        <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.label.error,'d-none':!el.validateError.label.error}"><small>{{el.validateError.label.message}}</small> </span>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">                        
                        <input type="text" class="form-control" name="menu_item_url" @change="el.validateError.url.error=false" v-model="el.url">
                        <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.url.error,'d-none':!el.validateError.url.error}"><small>{{el.validateError.url.message}}</small> </span>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">                        
                        <select class="form-control" name="menu_item_category_id" @change="el.validateError.category_id.error=false" v-model="el.category_id">
                        <option value="">ประเภท</option>
                            <option v-for="category in categories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                        </select>
                        <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.category_id.error,'d-none':!el.validateError.category_id.error}"><small>{{el.validateError.category_id.message}}</small></span>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">                        
                        <select class="form-control" name="menu_item_status" @change="el.validateError.disabled.error=false" v-model="el.disabled">
                            <option value="">สถานะ</option>
                            <option :value=0>เปิดใช้งาน</option>
                            <option :value=1>ปิดการใช้งาน</option>
                        </select>
                        <span class="help-block text text-danger" v-bind:class="{'d-block':el.validateError.disabled.error,'d-none':!el.validateError.disabled.error}"><small>{{el.validateError.disabled.message}}</small></span>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pl-5">
            <nested-menu-draggable class="sub-items" :list="el.children" :categories="categories" />
          </div>
        </div>
      </li>
      
  </draggable>
</template>
<script>
import draggable from "vuedraggable"; //https://github.com/SortableJS/Vue.Draggable
export default {
  name: "nested-menu-draggable",
  methods: {
    resetErrorStatus(el){
      el = false;
    },
    emitter(value) {
      this.$emit("input", value);
    },
    deleteClicked(index){
      this.list.splice(index, 1);
    },handleChange() {
      // console.log('changed');
    },
    inputChanged(value) {
      // console.log(value)
      this.activeNames = value;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    }    
  },
  components: {
    draggable  
  },
  computed: {
    dragOptions() {
      return {
        animation: 1,
        group: "description",
        disabled: false,
        ghostClass: "g1"
      };
    },
    // this.value when input = v-model
    // this.list  when input != v-model
    realValue() {
      // return this.list;
      // return this.value;
      return this.value ? this.value : this.list;
    }
  },  
  props: {
    list: {
      required: false,
      // type: Array
    },
    value: {
      required: false,
      // type: Array
    },
    categories: {
      required: false,
      // type: Object
    }
  }
};
</script>
<style scoped>
.dragArea {  
  border-radius: 0.25rem;
 
  min-height: 30px;
  outline: 1px #ddd solid;  
 
  
}
span.handle{
  cursor:move;  
}
.dragArea .element {
  list-style-type:none;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
}
.sub-items{
  min-height: 30px;
  margin-top:inherit;
}

/* .item-container {
  max-width: 20rem;
  margin: 0;
}
.item {
  padding: 1rem;
  border: solid black 1px;
  background-color: #fefefe;
}
.item-sub {
  margin: 0 0 0 1rem;
} */

</style>